<template>
  <div>
    <mdb-modal centered @close="$store.commit('clearCurrentModal')" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">{{
          options.title
        }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="text-center">
        <p class="mb-4 mt-n3">{{ options.content }}</p>
        <mdb-btn
          class="btn btn-isi"
          @click.native="$store.commit('clearCurrentModal')"
          >Ok</mdb-btn
        >
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>
